
<div ref="list" class="iztVnode-container" @scroll="scrollEvent($event)">
  <div class="iztVnode-wall" :style="{ height: listHeight + 'px' }" />
  <ul class="iztVnode" :style="{ transform: getTransform }">
    <slot :vDota="showData" :config="config" />
  </ul>
</div>
